import { InputChoice } from 'components/formInputs/types';

import { Severity, SleepApneaFormValues } from './types';

export const SEVERITIES: Array<InputChoice<Severity>> = [
  { label: 'Mild', value: 'mild' },
  { label: 'Moderate', value: 'moderate' },
  { label: 'Severe', value: 'severe' },
];

export const LABELS: Record<keyof SleepApneaFormValues, string> = {
  apneaHypopneaIndex: 'Apnea-hypopnea index (optional)',
  apneaIndex: 'Apnea index (optional)',
  diagnosedAt: 'When were you diagnosed with sleep apnea?',
  everTreated: 'Have you received treatment?',
  oxygenSaturation: 'Oxygen saturation (optional)',
  respiratoryDisturbanceIndex: 'Respiratory disturbance index (optional)',
  severity: 'What was your diagnosis?',
  sleepStudyConducted: 'Have you done an overnight sleep study?',
  sleepStudyConductedAt: 'When was the sleep study?',
  treatedAt: 'When was the treatment?',
  usesCPAPMachine: 'Do you use a CPAP machine?',
};
